// extracted by mini-css-extract-plugin
export default {"modalBox":"ImportantInfos_modalBox__L++EZ","closeBox":"ImportantInfos_closeBox__elaw3","closeButton":"ImportantInfos_closeButton__H4ssZ"};